import React, { useState } from 'react';
import { DtoDataReqLogin } from '../../Dto/DtosHome/DtosHomeRequest/DtoHomeRequestLogin';
import { DtoDataResLogin } from '../../Dto/DtosHome/DtosHomeResponse/DtoHomeResponseLogin';
import ApiLoginClubElite from '../../Api/ApiHome/ApiLoginClubElite';
import { FeatureGetSession } from "./FeatureGetSession";
import * as CryptoJS from "crypto-js";
// import Jwt from "jsonwebtoken";

export const FeatureHomeLoginClubElite = () => {
  const [loading, setLoading] = useState(false);
  const [requestDtoLogin, setRequestDto] = useState(DtoDataReqLogin);
  const [responseDtoLogin, setResponseDto] = useState(DtoDataResLogin);
  const [mostrarElegirModulo, setMostrarElegirModulo] = useState(false)

  const LoginClubElite = (e) => {
    var linkBase = window.location.pathname.split('/');
    let data = {
      token: linkBase[2]
    }
    if (linkBase[1] === 'out-link') {
      // var tokenJwt = Jwt.sign({ data: 'creacionToken' }, 'Db', { expiresIn: 360 });
      // localStorage.setItem("jwt", tokenJwt);
      ApiLoginClubElite(data).then(succ1 => {
        localStorage.setItem("token", CryptoJS.AES.encrypt(succ1.data.token, "eco_scotia"));
        if (succ1.codigo === 0) {
          FeatureGetSession(succ1.data.token)
        }
      }).catch(error => {
        console.log(error);
      });
    }
  };

  return {
    requestDtoLogin,
    responseDtoLogin,
    loading,
    LoginClubElite,
    mostrarElegirModulo,
  }

}

export default FeatureHomeLoginClubElite;